// extracted by mini-css-extract-plugin
module.exports = {"studentInternshipModalFooter":"StudentsTable_studentInternshipModalFooter__1zlIa"};